import { mixpanel } from '@fiverr-private/obs';

const PAGE_NAME = 'hollywood';

export const MIXPANEL_EVENTS = {
    PAGE_VIEW: 'Hollywood - Page View',
    CLICKED_HEADER_CTA: 'Hollywood - Clicked Header CTA',
    CLICKED_HERO_CTA: 'Hollywood - Clicked Hero CTA',
    CLICKED_DIRECTOR: 'Hollywood - Clicked Director',
    CLICKED_DIRECTOR_CTA: 'Hollywood - Clicked Director CTA',
    CLICKED_CINEMATIC_CTA: 'Hollywood - Clicked Cinematic CTA',
    FORM_SUBMITTED: 'Hollywood - Form Submitted',
    DIRECTORS_SECTION_VIEWED: 'Hollywood - Directors Section Viewed',
    CINEMATIC_SECTION_VIEWED: 'Hollywood - Cinematic Section Viewed',
    BOOKING_SECTION_VIEWED: 'Hollywood - Booking Section Viewed',
} as const;

interface MixpanelEventData {
    eventName: string;
    clickedElement?: string;
    elementSource?: string;
}

export const sendMixpanelEvent = (data: MixpanelEventData): void => {
    const eventData: Record<string, string> = { 'Page Name': PAGE_NAME };

    if (data.clickedElement) eventData['Clicked Element'] = data.clickedElement;

    if (data.elementSource) eventData['Element Source'] = data.elementSource;

    mixpanel.track(data.eventName, eventData);
};
